import axios from 'axios';

let port = '5000';
//let port = '5050'; //this can be used to point to other db using socat socat TCP-LISTEN:5050,reuseaddr,fork TCP:auth:5000

if (process.env.REACT_APP_DATABASE_CONTROLLER_PORT != null) {
  port = process.env.REACT_APP_DATABASE_CONTROLLER_PORT;
}

const isSecure = window.location.protocol === 'https:';
const baseUrl = isSecure ? '/api/' : 'http://' + window.location.hostname + ':' + port + '/';

export const API_URL = baseUrl;

export const AxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
});

export const AxiosInstanceLongTimeOut = axios.create({
  baseURL: baseUrl,
  timeout: 600000,
});

export function resolveImageUrl(url?: string | null): string {
  if (!url) return '';
  const trimmed = url.trim();
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanUrl = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base}${cleanUrl}`;
}
